(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }
  const initPlpInlineSliders = () => {
  

    if (typeof window.Swiper === 'function') {
      document.querySelectorAll('[id^="recomended--"] .recomended-products-swiper-container').forEach((container) => {
     
        if (container.dataset.inlineSwiperInit === 'true') return;
        const root = container.closest('[id^="recomended--"]');
        if (!root) return;
        const paginationEl = root.querySelector('.recommended-produts.swiper-pagination.recommended-products');
        const nextBtn = root.querySelector('.swiper-button-next.recommended-swiper-btn');
        const prevBtn = root.querySelector('.swiper-button-prev.recommended-swiper-btn');
        new window.Swiper(container, {
          slidesPerView: 4,
          spaceBetween: 10,
          navigation: { nextEl: nextBtn, prevEl: prevBtn },
          pagination: { el: paginationEl, clickable: true, type: 'bullets' },
          breakpoints: {
            0: { slidesPerView: 2, spaceBetween: 10 },
            750: { slidesPerView: 4, spaceBetween: 10 },
          },
        });
        container.dataset.inlineSwiperInit = 'true';
       
      });
      document.querySelectorAll('[id^="best-seller--"] .best-seller-products-swiper-container').forEach((container) => {
    
        if (container.dataset.inlineSwiperInit === 'true') return;
        const root = container.closest('[id^="best-seller--"]');
        if (!root) return;
        const paginationEl = root.querySelector('.swiper-pagination');
        const nextBtn = root.querySelector('.swiper-button-next.best-seller-swiper-btn');
        const prevBtn = root.querySelector('.swiper-button-prev.best-seller-swiper-btn');
        new window.Swiper(container, {
          slidesPerView: 4,
          spaceBetween: 10,
          navigation: { nextEl: nextBtn, prevEl: prevBtn },
          pagination: { el: paginationEl, clickable: true, type: 'bullets' },
          breakpoints: {
            0: { slidesPerView: 2, spaceBetween: 10 },
            750: { slidesPerView: 4, spaceBetween: 10 },
          },
        });
        container.dataset.inlineSwiperInit = 'true';
  
      });
    }


    if (typeof window.initCustomMainRecommened === 'function') {
      window.initCustomMainRecommened();
    }
    if (typeof window.initBestSellerSwiper === 'function') {
      window.initBestSellerSwiper();
    }
    if (typeof window.youmightbeproducts === 'function') {
      window.youmightbeproducts();
    }
    if (typeof window.initPlpCustomizerBannerSliders === 'function') {
      window.initPlpCustomizerBannerSliders();
    }
    if (typeof window.initRevampPlpBannerSliders === 'function') {
      window.initRevampPlpBannerSliders();
    }
  };

  

  const observePlpGridForSliderInit = () => {
 
    const grid = document.querySelector('[ref="grid"]');
    if (!grid) return;


    const observer = new MutationObserver(() => {
      initPlpInlineSliders();
 
    });

     observer.observe(grid, { childList: true, subtree: false });
  };

  document.addEventListener(
    'DOMContentLoaded',
    () => {
      initPlpInlineSliders();
      observePlpGridForSliderInit();
    },
    { once: true }
  );
  document.addEventListener('filter:update', () => {
    requestAnimationFrame(() => {
      initPlpInlineSliders();
    });
  });
  document.addEventListener('shopify:section:morphed', () => {
    requestAnimationFrame(() => {
      initPlpInlineSliders();
    });
  });
  

  } catch(e) { console.error(e); }
})();
})();
